export default __webpack_public_path__ + "static/1265-3685ada94aac426a57defd83820fd983.gif";